import { graphql } from '@/gql/client';

export const PageFieldsFragment = graphql(`
  fragment PageFieldsFragment on Page {
    ...PageSummaryFieldsFragment
    content
    seo {
      ...PostTypeSeoFieldsFragment
    }
    pageCustomFields {
      sidetext {
        text
        placement
      }
      enableOverlayNavbar
      enableLines
      theme
      hideFooterDivider
      hideSidetext
    }
  }
`);
